import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthServiceProvider, AuthService, UserRole} from "../../services/col2/auth.service";

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.css']
})
/*
This is the root page responsible for routing the users
depending on their roles. If the user is not logged in it
shows the welcome content. For non captured user roles the page may show
optional navigation.
*/
export class RootComponent implements OnInit {

  constructor(private authService: AuthServiceProvider,
  private router: Router) { }
  initialized = false;
  ngOnInit() {
    this.authService.get().subscribe(api => {
      this.initialized = true;
      this.routeToUserPage(api);
    });
  }
  public logout(authApi: AuthService) {
    authApi.logout();
  }
  routeToUserPage(authApi: AuthService) {
    if (authApi.isTokenValid()) {
      authApi.getUserRole().subscribe(
        userRole => {
          if (userRole === UserRole.Unknown || userRole === UserRole.Unauthorized) {
            this.logout(authApi);
          } else if (userRole === UserRole.Student) {
            this.router.navigate(['student', authApi.getStudentId(), 'dashboard']);
          } else if (userRole === UserRole.Teacher) {
            this.router.navigate(['teacher', authApi.getTeacherId(), 'dashboard']);
          } else if (userRole === UserRole.Admin) {
            this.router.navigate(['school', authApi.getSchoolId(), 'dashboard']);
          } else {
            this.router.navigate(['forbidden']);
          }
        }
      )
    }

  }
}
